export const PATHS = {
  // Default
  DEFAULT: "/",
  DELETE_USER: "/delete-user",

  // Auth
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  REGISTRATION: "/registration",
  // Dashboard Module
  DASHBOARD: "/dashboard",
  ADD_POST: "/addPost",

  // User management
  USER: "/users",
  USER_LIST: "user-list",
  WORKER_LIST: "worker-list",
  ADMIN_USER: "admin-users",

  //Statistics
  STATISTICS: "/statistics",
  WORKER_STATISTICS: "worker-statistics",
  WORKER_STATISTICS_REPORT: "worker-statistics-report",

  // Content management
  CONTENT: "/content",
  STATIC_PAGES: "static-pages",
  BLOGS: "blogs",
  BLOG_LIST: "blog-list",
  BLOG_CATEGORY: "blog-category",
  BLOG_CATEGORY_VIEW: "/blog-category-details/:id",
  FAQS: "faqs",
  FAQS_LIST: "faq-list",
  FAQS_CATEGORY: "faq-category",

  // Role
  ROLE: "/role",
  // Club management

  CLUB: "/clubs",
  CLUB_ADMIN_LIST: "club-admin-list",
  CLUBS_POSTS_LIST: "clubs-posts-list",

  BRAND: "/brand",
  BRAND_ADMIN_LIST: "/brand-admin-list",
  BRAND_POSTS_LIST: "/brand-posts-list",
  BRAND_SURVEY_LIST: "/brand-survey",

  // Email And Notification
  EMAIL_TEMPLATES: "/email-templates",

  // Master management
  MASTER_MANAGEMENT: "/master",
  COUNTRY: "country",
  TIMEZONE: "timezone",
  LANGUAGE: "language",
  CITIES: "cities",
  ZONES: "zones",
  CLUB_TYPE: "club-type",
  MUSIC_TYPE: "music-type",
  OUTFITS: "outfits",
  DRINK_TYPE: "drink-type",

  PLANS: "plans",

  //categoy
  CATEGORY: "/category",
  LEVELS: "levels",
  SUPER_LEVELS: "super-levels",
  ACTIONS: "actions",
  BENEFITS: "benefits",
  ATMOSPHERE_RANGES: "atmosphere_ranges",
  QUE_TYPE: "que_type",
  GENDER_MIX: "gender",

  // Support
  SUPPORT: "/support",

  // Settings
  SETTINGS: "/settings",
  GENERAL_SETTINGS: "general-settings",
  SOCIAL_MEDIA: "social-media",
  PAYMENT_GATEWAY: "payment-gateway",
  SMTP_SMS_DETAILS: "smtp-details",
  EMAIL_NOTIFICATIONS: "email-notifications",
  LANGUAGE_MESSAGES: "language/messages",
  LANGAUGE_STATIC_LANG: "language/static-label",

  // Common Pages
  FourZeroFour: "/common/404",
  THANKYOU: "/common/thankyou",
  COMING_SOON: "/common/coming-soon",

  // Profile
  MY_PROFILE: "/profile",
  EDIT_MY_PROFILE: "/profile/edit-profile",

  // Change Password
  CHANGE_PASSWORD: "/change-password",

  //manage promotion
  PROMOTION: "/manage-promotion",
  PROMOTION_DETAILS: "/promotion-details",

  //Brand Subscribers List
  SUBSCRIBERS_LIST: "/subscribers-list",

  //REPORTS
  REPORTS: "/reports",
  ADMIN_MONITORING: "admin-monitoring",
  SUPER_CLUB_REPORT: "super-club-report",
  SUPER_BRAND_REPORT: "super-brand-report",
  SUPER_USER_REPORT: "super-user-report",
  CLUB_STATS_DETAILS: "club-stats-details",
  BRAND_STATS_DETAILS: "brand-stats-details",

  //club admin
  CLUB_ADMIN_REPORTS: "/club-reports",
  CLUB_USER_REPORTS: "/users",
  CLUB_MONITOR_REPORTS: "/monitoring",
  //Brand admin
  BRAND_ADMIN_REPORTS: "/brand-reports",
  BRAND_USER_REPORTS: "/brand-users",
  BRAND_MONITOR_REPORTS: "/brand-monitoring",

  //promo
  MANAGE_BENEFITS: "/manage-benefits",
  MANAGE_POINTS: "/manage-points",

  // Ui Kit
  UI_KIT: "/uikit",
  TYPOGRAPHY: "typography",
  COLORS: "colors",
  FORMS: "forms",
  CARDS: "cards",
  BLOCKS: "blocks",
  // Extras
  ANY: "*",
  VIEW: "view",
  CREATE: "create",
  EDIT: "edit",
  WORKER: "worker",
};
